import { Route } from '@angular/router';
import { initialDepsResolver } from 'app/app.resolvers';
import { AuthGuard } from 'app/core/auth/guards/auth.guard';
import { NoAuthGuard } from 'app/core/auth/guards/noAuth.guard';

import { Constants } from './core/constants/constants';

// @formatter:off
/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
export const appRoutes: Route[] = [
    // Redirect empty path to '/example'
    // {path: '', pathMatch : 'full', redirectTo: Constants.entryRoute},

    // pages routes
    {
        path: Constants.entryRoute,
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard],
        loadComponent: () => import('app/layout/layout.component').then(m => m.LayoutComponent),
        data: {
            layout: 'dense'

        },
        resolve: {
            initialData: initialDepsResolver
        },
        children: [
            { path: '', loadChildren: () => import('app/modules/pages/pages.routes') },
        ]
    },

    // Auth routes for guests
    {
        // we may change this empty route '' => 'auth' for auth pages
        path: '',
        canActivate: [NoAuthGuard],
        canActivateChild: [NoAuthGuard],
        loadComponent: () => import('app/layout/layout.component').then(m => m.LayoutComponent),
        data: {
            layout: 'empty'
        },
        children: [
            { path: Constants.confirmationRequiredRoute, loadChildren: () => import('app/modules/auth/confirmation-required/confirmation-required.routes') },
            { path: Constants.forgetPasswordRoute, loadChildren: () => import('app/modules/auth/forgot-password/forgot-password.routes') },
            { path: Constants.resetPasswordRoute, loadChildren: () => import('app/modules/auth/reset-password/reset-password.routes') },
            { path: Constants.setPasswordRoute, loadChildren: () => import('app/modules/auth/set-password/set-password.routes') },
            { path: Constants.loginRoute, loadChildren: () => import('app/modules/auth/sign-in/sign-in.routes') },
            { path: Constants.registerRoute, loadChildren: () => import('app/modules/auth/sign-up/sign-up.routes') },
            { path: Constants.guestRegisterRoute, loadChildren: () => import('app/modules/auth/guest-register/guest-register.routes') },
            { path: Constants.activateAccountRoute, loadChildren: () => import('app/modules/auth/account-activation/account-activation.routes') },

        ]
    },

    // Auth routes for authenticated users
    {
        path: '',
        // canActivate: [AuthGuard],
        // canActivateChild: [AuthGuard],
        loadComponent: () => import('app/layout/layout.component').then(m => m.LayoutComponent),
        data: {
            layout: 'empty'
        },
        children: [
            { path: Constants.logoutRoute, loadChildren: () => import('app/modules/auth/sign-out/sign-out.routes') },
        ]
    },
    /** wildcard route */
    {
        path: '**',
        redirectTo: Constants.notFoundRoute
    },
    {
        path: Constants.notFoundRoute,
        loadChildren: () => import('app/modules/pages/errors/error-404/error-404.routes')
    }


];
